module.exports = __webpack_public_path__ + "img/4S.638bc73f.png";